import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';

const CoOwnersTableHeader: FC = () => {
  const { t } = useTranslate();

  const columns = [
    { key: 'co-owner-name', content: t('Name') },
    { key: 'cif', content: t('Cif') },
    { key: 'email', content: t('Email') },
    { key: 'percent', content: t('Percent'), textPosition: 'right' },
  ].filter(Boolean) as ColumnCell[];

  return (
    <TableHeader columns={columns} rowClassName="co-owners-table-header" />
  );
};

export default CoOwnersTableHeader;
